
import { ConnectorController, ConnectorControllerUtil, } from '@reown/appkit-controllers';


export const connectAnonClient = async () => {
	const { VITE_ANON_WALLET_PK, VITE_ANON_WALLET_ADDR, } = import.meta.env;
	if(!VITE_ANON_WALLET_PK || !VITE_ANON_WALLET_ADDR) {
		console.error("connectAnonClient:: no anon wallet pk or addr found to sign in anon");
		throw new Error("WalletSlice:: no anon wallet pk or addr found to sign in anon");
	}

	const MockConnector = ConnectorController.state.connectors.find(c => c.id === 'anonymous');
	if(MockConnector) {
		await ConnectorControllerUtil.connectExternal(MockConnector);
		return;
	}

	// hiding selector: 
	// document.querySelector('w3m-modal').shadowRoot.querySelector('wui-flex').querySelector('wui-card > w3m-router').shadowRoot.querySelector('w3m-router-container > w3m-connect-view').shadowRoot.querySelector('wui-flex > wui-flex > wui-flex > w3m-wallet-login-list').shadowRoot.querySelector('wui-flex > w3m-connector-list').shadowRoot.querySelector('wui-flex > w3m-connect-external-widget')
	console.error("connectAnonClient:: no mock connector found to sign in anon");
	throw new Error("WalletSlice:: no mock connector found to sign in anon");
};
